module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAOCAYAAADaOrdAAAABNUlEQVQ4T6WUOU4EMRBF/5cAiRMQEXAGu25AgoAIbjAsGdIk3IEIkTIsARIELCfgBtW+AhEJ3IEuZGRGHjO9TNNpd9erV/VtquoWyUsAq2Y2FpE7/ONR1U2SFwBoZici8sqqqt4AbKS6ZmaHInI9hFNV1TaAFwAr6f937/16CYnvBoFCCDtm9pwBYq1P7/0aQwi7ZhbpS1n3BuDIe3/Vx6gBYCRHzrlbxiKquk/yYQgoNflUGETAsXNuEuv/QIaCmgDlFKaQRUF9ATMmhdE9gOV8R7n+IoC5kMxoLqiu6w+Sj+UO2qI/M648SSkMf0AAvsqAdJ2tRkgy2kupy0eX9xLP1IGI3LRFvRXSAaqTQSugcSdlV6oajeIepk2Z2ajL4LdOp0mWujHJs3TxnYvIaZ/bIH7zDfpcuQ+4ptc4AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/images/shootShop/more.png
// module id = PMxj
// module chunks = 1